import { mergeArcs } from 'topojson';
import { staticRegions } from '../model/StaticVariables';

//json: topojson file
//stateAbbbrArr: array of state abbreviations to whitelist ex: ["NY","NJ"]
//returns: original json altered, with geometry that matches state whitelist
const filterJsonByStates = (json, stateAbbrArr) => {
    var objectKeyName = Object.keys(json.objects)[0];
    var filteredObjects = json.objects[objectKeyName].geometries.reduce((out, st) => {
        const abbr = st.properties.STUSPS;
        if (stateAbbrArr.includes(abbr)) {
            out.push(st);
        }
        return out;
    }, []);
    const clonedData = JSON.parse(JSON.stringify(json));
    clonedData.objects[objectKeyName].geometries = filteredObjects;
    return clonedData;
};
export { filterJsonByStates };
//returns true if the geometry is in the specified region
const geometryIsWithinRegion = (geometry, regionID) => {
    const whiteListAbbr = staticRegions[regionID].states;
    const currentStAbbr = geometry.properties.STUSPS;
    return whiteListAbbr.includes(currentStAbbr);
};
//return a filtered array of all geometries that are within the specified region
const filterGeometryByRegion = (json, regionID) => {
    var objectKeyName = Object.keys(json.objects)[0];
    return json.objects[objectKeyName].geometries.reduce((out, geom) => {
        if (geometryIsWithinRegion(geom, regionID)) {
            out.push(geom);
        }
        return out;
    }, []);
};
//create a copy of a topojson that merges objects based on region.
//each gometry object must have a STUSPS property that is a 2 digit state abbreviation
const mergeJsonByRegion = (json) => {
    const objectKeyName = Object.keys(json.objects)[0];
    const regions = staticRegions.filter((r) => r.hasOwnProperty('states')); //only state regions not hhs

    //clone data to prevent mutation
    const clonedJson = JSON.parse(JSON.stringify(json));
    clonedJson.objects[objectKeyName].geometries = [];

    //Loop through regions and merge states matching list in region
    for (let i = 0; i < regions.length; i++) {
        const regionGeometry = filterGeometryByRegion(json, i);
        const mergedRegion = mergeArcs(json, regionGeometry);
        mergedRegion.properties = { id: regions[i].id };
        clonedJson.objects[objectKeyName].geometries.push(mergedRegion);
    }
    return clonedJson;
};
export { mergeJsonByRegion };
